import { useEffect } from 'react';

/**
 * Loads the CookieYes banner script for the given CookieYes client ID
 * (see brandCookieYesId in utils/getBrand.jsx). Brands with
 * brandCookieYesAllPages load it site-wide from App.jsx, the rest only on
 * their homepage; once loaded it stays active for the rest of the SPA session.
 * @param {string | undefined} cookieYesId
 */
export const useCookieYes = (cookieYesId) => {
  useEffect(() => {
    // CookieYes throws on domains not registered in its dashboard (e.g. localhost),
    // so only load it in production builds.
    if (process.env.NODE_ENV !== 'production') return;
    if (!cookieYesId || document.getElementById('cookieyes')) return;

    const script = document.createElement('script');
    script.id = 'cookieyes';
    script.type = 'text/javascript';
    script.src = `https://cdn-cookieyes.com/client_data/${cookieYesId}/script.js`;
    document.head.prepend(script);
  }, [cookieYesId]);
};
